import React from 'react';
import NavMenu from './NavMenu';

const Layout = ({ children }) => {
    return (
        <div>
            <NavMenu />
            <main>
                {children}
            </main>
        </div>
    );
};

export default Layout;
